/** Customer purposes. Runtime roles remain the authority boundary on the server. */
export const EDGE_USE_CASES = [
  {
    role: "web",
    title: "Private application access",
    description: "Let people securely use your internal web applications.",
    setup: "Choose the applications, assign people or groups, and verify browser access.",
  },
  {
    role: "privileged",
    title: "Private server access",
    description: "Let people open terminal sessions to your internal servers from a browser, without sharing server credentials.",
    setup: "Register the servers, assign people or groups, and verify a terminal session.",
  },
  {
    role: "broker",
    title: "Agent API governance",
    description: "Control agent actions against internal and supported third-party APIs.",
    setup: "Register APIs and actions, then configure agent access, limits and approval policies.",
  },
  {
    role: "egress",
    title: "Agent outbound access",
    description: "Allow encrypted agent connections to approved destinations. Edge cannot inspect actions inside these connections.",
    setup: "Register destinations and authorize workloads. Encrypted tunnels do not expose application actions to Edge.",
  },
] as const;

export type EdgeUseCaseRole = typeof EDGE_USE_CASES[number]["role"];

/** Runtimes a person's browser reaches: enrolled by one approved key, never by a workload class. */
export function admitsPeople(role: string): boolean {
  return role === "web" || role === "privileged";
}

export function edgeUseCase(role: string) {
  return EDGE_USE_CASES.find((item) => item.role === role);
}
